import { Injectable } from '@angular/core';
import { GenericStateService } from '../../generic-state/generic-state.service';

@Injectable({
  providedIn: 'root'
})
export class FleetStoreService extends GenericStateService<any> {}
